// Import the functions you need from the Firebase SDKs
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC_fZjkSeMrFufsl7kRr1yyemrCjYcr_-c",
  authDomain: "rotary-stypendium.firebaseapp.com",
  projectId: "rotary-stypendium",
  storageBucket: "rotary-stypendium.appspot.com",
  messagingSenderId: "837887431107",
  appId: "1:837887431107:web:6694e1114afe9e14d5ed76",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const firestore = getFirestore(app);
const db = firestore
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const storage = getStorage(app);

export { firestore, auth, provider, storage ,db};
